import { setInterval, clearInterval, Observable, ONE_SECOND, findCommaSeparatedValue } from '@datadog/browser-core';
export var WATCH_COOKIE_INTERVAL_DELAY = ONE_SECOND;
export function createCookieObservable(cookieName) {
  return new Observable(function (observable) {
    return (
      // NOTE: we don't use cookiestore.addEventListner('change', handler) as it seems to me more prone to bugs
      // and cause our tests to be flaky (and probably in production as well)
      watchCookieStrategy(cookieName, function (event) {
        return observable.notify(event);
      })
    );
  });
}
function watchCookieStrategy(cookieName, callback) {
  var previousCookieValue = findCommaSeparatedValue(document.cookie, cookieName);
  var watchCookieIntervalId = setInterval(function () {
    var cookieValue = findCommaSeparatedValue(document.cookie, cookieName);
    if (cookieValue !== previousCookieValue) {
      callback(cookieValue);
    }
  }, WATCH_COOKIE_INTERVAL_DELAY);
  return function () {
    return clearInterval(watchCookieIntervalId);
  };
}